
import React, { useState, useEffect } from 'react';
async function decryptAESGCM(cipherTextBase64, key, iv) {
    try {
      // Decode the key and IV from UTF-8 to ArrayBuffer
      const keyBuffer = new TextEncoder().encode(key);
      const ivBuffer = new TextEncoder().encode(iv);
  
      // Import the key for decryption
      const cryptoKey = await window.crypto.subtle.importKey(
        'raw',
        keyBuffer,
        'AES-GCM',
        false,
        ['decrypt']
      );
  
      // Decode the cipher text from Base64 to ArrayBuffer
      const cipherTextBuffer = Uint8Array.from(atob(cipherTextBase64), c => c.charCodeAt(0));
  
      // Decrypt the cipher text
      const decryptedBuffer = await window.crypto.subtle.decrypt(
        {
          name: 'AES-GCM',
          iv: ivBuffer,
          tagLength: 128, // 128 bits
        },
        cryptoKey,
        cipherTextBuffer
      );
  
      // Convert the decrypted ArrayBuffer to a UTF-8 string
      const decryptedText = new TextDecoder().decode(decryptedBuffer);
  
      return decryptedText;
    } catch (error) {
      console.error('Decryption failed:', error);
      return null;
    }
  }

function Decryption() {
    const [decryptedText, setDecryptedText] = useState('');

    useEffect(() => {
      const cipherTextBase64 = '8kgmPMFBX583uzz6IehC2EUDU8CQK9ND9kSx';
      const key = 'J@@zGc@re_!2024!J@@zGc@re_!2024#';
      const iv = '#Gc@reJ@@z_2024!';
  
      decryptAESGCM(cipherTextBase64, key, iv).then((text) => {
        setDecryptedText(text);
      });
    }, []);
  
    return (
      <div>
        <h1>Decrypted Text:</h1>
        <p>{decryptedText}</p>
      </div>
    );
  }
  

export default Decryption;
